'use strict';

var defineProperty = require('../../node_modules/@babel/runtime/helpers/defineProperty.js');
var React = require('react');
var SvgIcon = require('../../library/DataDisplay/SvgIcon.js');
var iconStyles = require('../iconStyles.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var OnlineBooking = function OnlineBooking(props) {
  return React__default["default"].createElement(SvgIcon, _objectSpread({}, props, {
    viewBox: "0 0 24 24"
  }), React__default["default"].createElement("path", {
    d: "M23,11.01L18,11c-0.55,0-1,0.45-1,1v9c0,0.55,0.45,1,1,1h5c0.55,0,1-0.45,1-1v-9C24,11.45,23.55,11.01,23,11.01z M23,20h-5\n\tv-7h5V20z M20,2H2C0.89,2,0,2.89,0,4v12c0,1.1,0.89,2,2,2h7v2H7v2h8v-2h-2v-2h2v-2H2V4h18v5h2V4C22,2.89,21.1,2,20,2z"
  }), React__default["default"].createElement("g", {
    transform: "translate(0,-952.36218)"
  }, React__default["default"].createElement("path", {
    d: "M12.069,957.779l-3.792,5.267h2.317l-1.159,3.792l3.897-5.267h-2.317L12.069,957.779z"
  })));
};

var OnlineBooking$1 = iconStyles()(OnlineBooking);

module.exports = OnlineBooking$1;
